export default __webpack_public_path__ + "locales/lv/Translations.json?hash=2656ab101b329bc2380c2ce284184e3c";